import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useI18n } from "../../../hooks/useI18n";
import { AppState } from "../../../store";
import { DiscountState } from "../../../store/discounts/types";
import { Discount } from "../../../models/Discount";
import { useDiscountEditContext } from "../index";
import { DiscountEditorDialog } from "./DiscountEditorDialog";

export const EditDiscount = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useI18n();

  const discountState = useSelector<AppState, DiscountState>(s => s.discounts);
  const { discounts, discountTypes, isLoading } = discountState;
  const [discount, setDiscount] = useState<Discount>();
  const { updateDiscount } = useDiscountEditContext();

  useEffect(() => {
    if (!isLoading && discounts.length) {
      setDiscount(discounts.find(d => d.id === params.discountId));
    }
  }, [discounts]);

  const onCancel = () => navigate("..");
  const onConfirm = (...params: any) => {
    updateDiscount(...params);
    onCancel();
  };

  return (
    <DiscountEditorDialog
      title={t("common.actions.editCoupon")}
      isLoading={isLoading}
      discountTypes={discountTypes}
      isEditing={true}
      discount={discount}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};
